module.exports = __webpack_public_path__ + "img/IMG_2884-14304.f427d96a.jpg";